module.exports = __webpack_public_path__ + "img/whats-new-12_en.bd52593.jpg";